import styled from 'styled-components'
import Pointer from 'assets/images/Pointer.svg'
import { formBreakpoint } from 'globalStyles'

export const Container = styled.div`
  position: fixed;
  top: 30%;
  right: 1.6rem;
  width: 32rem;
  padding: 1.6rem 1rem;
  min-height: 20rem;
  max-height: calc(100vh - 31%);
  display: flex;
  flex-direction: column;

  background: var(--light);
  border: 1px solid var(--grey-400);
  box-shadow: 0 1px 1px var(--shadow);
  border-radius: 0.8rem;
  color: var(--text-dark);
  z-index: var(--flights-z-index);

  @media screen and (max-width: ${formBreakpoint}) {
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    max-height: 100%;
    border: 0;
    box-shadow: none;
    border-radius: 0;
    padding: 1.6rem 3rem;
    z-index: var(--flights-z-index);
  }
`

export const Heading = styled.h5`
  font-size: 1.6rem;
  line-height: 2.4rem;

  @media screen and (max-width: ${formBreakpoint}) {
    font-size: 2.4rem;
    line-height: 3.2rem;
    font-weight: 500;
  }
`

export const InnerContainer = styled.div`
  padding: 0 0.6rem;
  overflow-y: auto;
  overscroll-behavior: none;
`

export const SecondaryText = styled.p`
  color: var(--text-light);
  letter-spacing: 0.01em;
  word-wrap: break-word;
`

export const ListPredecoration = styled(SecondaryText)`
  font-size: 1rem;
  line-height: 1.6rem;
  flex-basis: 12%;
  margin-top: -0.8rem;
  text-align: center;

  @media screen and (max-width: ${formBreakpoint}) {
    font-size: 1.2rem;
  }
`

export const ItemHeading = styled.p`
  font-weight: 600;
  word-wrap: break-word;
`

export const WarningText = styled.p`
  color: var(--warning);
  white-space: nowrap;
`

export const List = styled.ul`
  padding-top: 0.8rem;
  margin-top: 2.4rem;
  min-height: fit-content;
`

export const Item = styled.li`
  display: flex;
  gap: 0.8rem;

  &:not(:last-child) > *:last-child {
    border-color: var(--grey-400);
    padding-bottom: 4rem;
  }
`

export const FlightItemDescription = styled.div`
  position: relative;
  border-left: 2px solid transparent;
  padding-left: 1.5rem;
  flex-basis: 80%;

  & > *:first-child {
    margin-top: -.8rem;
  }

  &::before {
    content: '';
    position: absolute;
    top: -.3em;
    left: -0.5rem;
    width: 0.8rem;
    height: 0.8rem;
    background-color: var(--grey-400);
    border-radius: 50%;
  }
`

export const LogosWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-top: 1.6rem;
`

export const LogosContainer = styled.div`
  position: relative;
  width: 2.4rem;
  height: 2.4rem;
  font-size: 0;
  & img {
    max-width: 100%;
    height: auto;
    cursor: url(${Pointer}), pointer;
  }
`

export const BackIconContainer = styled.div`
  display: none;
  margin-bottom: 5rem;
  cursor: url(${Pointer}), pointer;

  @media screen and (max-width: ${formBreakpoint}) {
    display: block;
  }
`

export const WarningContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  font-size: 1.4rem;
  margin-top: 1.6rem;

  @media screen and (max-width: ${formBreakpoint}) {
    font-size: 1.6rem;
  }
`

type LogoTooltipProps = {
  show: boolean
}

export const LogoTooltip = styled.span<LogoTooltipProps>`
  display: inline-block;
  padding: 0.2rem 1rem;
  max-width: 12rem;
  position: absolute;
  top: 125%;
  left: 50%;
  font-weight: 600;
  font-size: 1.2rem;
  line-height: 2rem;
  text-align: center;
  color: var(--light);
  border-radius: 6px;
  background: var(--dark);
  transform: translateX(-50%);
  opacity: ${(props) => (props.show ? 1 : 0)};
  will-change: opacity;
  z-index: 100;

  &::before {
    content: '';
    position: absolute;
    width: 8px;
    height: 8px;
    top: -4px;
    left: 50%;
    transform: translateX(-50%) rotate(45deg);
    border-top-left-radius: 2px;
    background-color: var(--dark);
  }
`
